// src/components/layout/Navbar.jsx
import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || 'http://localhost:5001';
const SPA_URL   = process.env.REACT_APP_SPA_URL   || 'http://localhost:3000';

function resolveUser(url) {
  if (!url) return null;
  return url.startsWith('http') ? url : `${MEDIA_URL}${url}`;
}

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef();

  const avatarSrc = resolveUser(user?.avatar_url);

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <nav style={{
      position:'fixed', top:0, left:0, right:0, zIndex:100,
      height:'var(--nav-h)',
      background:'rgba(12,13,15,0.94)',
      backdropFilter:'blur(16px)',
      borderBottom:'1px solid var(--border)',
      display:'flex', alignItems:'center',
    }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', padding:'0 clamp(16px,4vw,48px)' }}>

        {/* Logo */}
        <Link to="/dashboard" style={{ display:'flex', alignItems:'center', gap:10, textDecoration:'none' }}>
          {/* Logo */}
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <img src="/logos/logo-dark.png" alt="MilleHills" style={{ height:32, width:'auto', objectFit:'contain' }}/>
            <div style={{ display:'flex', flexDirection:'column', justifyContent:'center', lineHeight:1 }}>
              <div style={{ fontFamily:'var(--font-display)', fontWeight:700, fontSize:14, color:'var(--t-primary)', letterSpacing:'-0.01em' }}>MilleHills</div>
              <div style={{ fontSize:9, color:'var(--gold)', letterSpacing:'0.2em', textTransform:'uppercase', fontWeight:700, marginTop:2 }}>Academy</div>
            </div>
          </div>
        </Link>

        {/* Right side */}
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>

          {/* My Courses */}
          <Link to="/dashboard"
            style={{ fontSize:'0.82rem', color:'var(--t-secondary)', padding:'7px 14px', borderRadius:8, textDecoration:'none', transition:'all 0.15s', border:'1px solid transparent' }}
            onMouseEnter={e=>{ e.currentTarget.style.color='var(--t-primary)'; e.currentTarget.style.background='var(--bg-2)'; }}
            onMouseLeave={e=>{ e.currentTarget.style.color='var(--t-secondary)'; e.currentTarget.style.background='transparent'; }}>
            My Courses
          </Link>

          {/* Back to main site */}
          <a href={SPA_URL} target="_blank" rel="noopener noreferrer"
            style={{ fontSize:'0.82rem', color:'var(--t-muted)', padding:'7px 14px', borderRadius:8, textDecoration:'none', transition:'all 0.15s', display:'flex', alignItems:'center', gap:5 }}
            onMouseEnter={e=>{ e.currentTarget.style.color='var(--gold)'; e.currentTarget.style.background='rgba(232,164,58,0.06)'; }}
            onMouseLeave={e=>{ e.currentTarget.style.color='var(--t-muted)'; e.currentTarget.style.background='transparent'; }}>
            millehills.com
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2.5 9.5L9.5 2.5M5.5 2.5H9.5V6.5"/>
            </svg>
          </a>

          {/* User menu */}
          {user && (
            <div ref={menuRef} style={{ position:'relative' }}>
              <button onClick={()=>setMenuOpen(v=>!v)}
                style={{ display:'flex', alignItems:'center', gap:8, padding:'5px 10px 5px 5px', borderRadius:24, background:menuOpen?'var(--bg-3)':'rgba(232,164,58,0.06)', border:'1px solid rgba(232,164,58,0.2)', cursor:'pointer', transition:'all 0.15s' }}
                onMouseEnter={e=>{ e.currentTarget.style.borderColor='rgba(232,164,58,0.4)'; }}
                onMouseLeave={e=>{ if(!menuOpen) e.currentTarget.style.borderColor='rgba(232,164,58,0.2)'; }}>

                {/* Avatar */}
                <div style={{ width:28, height:28, borderRadius:'50%', overflow:'hidden', background:'rgba(232,164,58,0.15)', border:'1px solid rgba(232,164,58,0.35)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  {avatarSrc
                    ? <img src={avatarSrc} alt={user.name} style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
                    : <span style={{ fontFamily:'var(--font-display)', fontWeight:700, fontSize:12, color:'var(--gold)' }}>{user.name?.[0]?.toUpperCase()||'U'}</span>
                  }
                </div>
                <span style={{ fontSize:'0.82rem', color:'var(--t-primary)', fontWeight:500, maxWidth:80, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                  {user.name?.split(' ')[0]}
                </span>
                <span style={{ fontSize:9, color:'var(--t-muted)' }}>▾</span>
              </button>

              {menuOpen && (
                <div style={{ position:'absolute', top:'calc(100% + 8px)', right:0, background:'rgba(14,16,20,0.98)', border:'1px solid var(--border)', borderRadius:14, backdropFilter:'blur(20px)', minWidth:220, padding:'8px', boxShadow:'0 12px 40px rgba(0,0,0,0.5)', animation:'fadeIn 0.15s ease', zIndex:200 }}>

                  {/* User info */}
                  <div style={{ padding:'10px 12px 14px', borderBottom:'1px solid var(--border)', marginBottom:6 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                      <div style={{ width:36, height:36, borderRadius:'50%', overflow:'hidden', background:'rgba(232,164,58,0.15)', border:'1px solid rgba(232,164,58,0.3)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                        {avatarSrc
                          ? <img src={avatarSrc} alt={user.name} style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
                          : <span style={{ fontFamily:'var(--font-display)', fontWeight:700, fontSize:14, color:'var(--gold)' }}>{user.name?.[0]?.toUpperCase()||'U'}</span>
                        }
                      </div>
                      <div>
                        <div style={{ fontSize:'0.88rem', fontWeight:600, color:'var(--t-primary)' }}>{user.name}</div>
                        <div style={{ fontSize:'0.72rem', color:'var(--t-muted)', marginTop:1 }}>{user.email}</div>
                      </div>
                    </div>
                  </div>

                  {/* Menu items */}
                  {[
                    { label:'My Courses',        icon:'◐', to:'/dashboard', internal:true },
                    { label:'My Profile',         icon:'◉', href:`${SPA_URL}/dashboard`, internal:false },
                    { label:'Browse Programs',    icon:'◈', href:`${SPA_URL}/academy`, internal:false },
                    { label:'My Certificates',    icon:'✓', href:`${SPA_URL}/dashboard`, internal:false },
                  ].map(item => (
                    item.internal
                      ? <Link key={item.label} to={item.to} onClick={()=>setMenuOpen(false)}
                          style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 12px', fontSize:'0.84rem', color:'var(--t-secondary)', borderRadius:8, transition:'all 0.1s', textDecoration:'none' }}
                          onMouseEnter={e=>{ e.currentTarget.style.background='var(--bg-3)'; e.currentTarget.style.color='var(--t-primary)'; }}
                          onMouseLeave={e=>{ e.currentTarget.style.background='transparent'; e.currentTarget.style.color='var(--t-secondary)'; }}>
                          <span style={{ fontSize:13, width:16 }}>{item.icon}</span>
                          {item.label}
                        </Link>
                      : <a key={item.label} href={item.href} target="_blank" rel="noopener noreferrer" onClick={()=>setMenuOpen(false)}
                          style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 12px', fontSize:'0.84rem', color:'var(--t-secondary)', borderRadius:8, transition:'all 0.1s', textDecoration:'none' }}
                          onMouseEnter={e=>{ e.currentTarget.style.background='var(--bg-3)'; e.currentTarget.style.color='var(--t-primary)'; }}
                          onMouseLeave={e=>{ e.currentTarget.style.background='transparent'; e.currentTarget.style.color='var(--t-secondary)'; }}>
                          <span style={{ fontSize:13, width:16 }}>{item.icon}</span>
                          {item.label}
                          <span style={{ fontSize:9, color:'var(--t-muted)', marginLeft:'auto' }}>↗</span>
                        </a>
                  ))}

                  <div style={{ borderTop:'1px solid var(--border)', marginTop:6, paddingTop:6 }}>
                    <button onClick={()=>{ setMenuOpen(false); logout(); navigate('/login'); }}
                      style={{ display:'flex', width:'100%', alignItems:'center', gap:10, padding:'8px 12px', fontSize:'0.84rem', color:'var(--red)', textAlign:'left', background:'none', border:'none', cursor:'pointer', borderRadius:8, transition:'background 0.1s', fontFamily:'inherit' }}
                      onMouseEnter={e=>e.currentTarget.style.background='rgba(240,96,96,0.08)'}
                      onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                      <span style={{ fontSize:13, width:16 }}>⏻</span>
                      Sign Out
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <style>{`@keyframes fadeIn { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:none; } }`}</style>
    </nav>
  );
}
